import * as Sentry from "@sentry/react";

Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    release: `bss@${process.env.REACT_APP_VERSION}`,
    environment: process.env.REACT_APP_STAGE,
    tracesSampleRate: 0.2
})